import { Dayjs } from 'dayjs';
import { BusinessModuleRef } from '../business-module-ref.js';
import { DataModel } from '../../dto/data-model.js';
import { BusinessLevelMarketingSubscriptionType } from './business-level-marketing-subscription-type.js';

export abstract class BusinessLevelMarketingSubscription extends DataModel {
  abstract get type(): BusinessLevelMarketingSubscriptionType;
  abstract get businessRef(): BusinessModuleRef;
  abstract get consentDate(): Dayjs;
  abstract get subscriptionDate(): Dayjs;
}
